import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '0.4fr 1fr 1fr',
    columnGap: 50,
  },
}));

const ProductDetailSkeleton = () => {
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <Skeleton variant="rect" height={173} width={173} />
      <Skeleton variant="rect" height={173} width={157} />
      <Skeleton variant="rect" height={173} width={130} />
    </Box>
  );
};

export default ProductDetailSkeleton;
